import { type ReactElement } from 'react';

export function RepTwoMinuteSummary(): ReactElement {
  return <div />;
}